import React, { useState } from 'react'
import "./QuestionView.css";
import parse from 'html-react-parser';

import Eckdusche from '../images/kachel_eckdusche';
import Nischendusche from '../images/kachel_nischendusche';
import WalkInDusche from '../images/kachel_walk-in-dusche';
import Schiebedusche from '../images/kachel_schiebedusche';
import Sonderloesungen from '../images/kachel_sonderloesungen';
import Andere from '../images/kachel_andere';


function QuestionView({Questions, currentQuestion, handleQuestionSelectClick, handleQuestionBackClick, Animation, WalkIn}) {
    const getAllQuestions = Questions.questions;
    const questionHeadline = Questions.questions[currentQuestion].question;

    const [checkboxValues, setCheckboxValues] = useState('');

    const [textStatus, setTextStatus] = useState(false);
    const [questionData, setQuestionData] = useState('');

    const getImage = (icon) => {

        switch (icon){
            case "kachel_eckdusche":
                return <Eckdusche/>;
                break;
            case "kachel_nischendusche":
                return <Nischendusche/>;
                break;
            case "kachel_walk-in-dusche":
                return <WalkInDusche/>;
                break;
            case "kachel_schiebedusche":
                return <Schiebedusche/>;
                break;
            case "kachel_sonderloesungen":
                return <Sonderloesungen/>;
                break;
            case "kachel_andere":
                return <Andere/>;
                break;
            default:
                return <Andere/>;
        }
    }

    const onCheckedValue = (e) => {
        const { checked, value } = e.target;
        if(checked){
            setCheckboxValues([...checkboxValues, value])
        }else{
            setCheckboxValues(checkboxValues.filter((item) => item !== value));
        }    
    }

    const handleInputChange = (e) => {
        setQuestionData(e.target.value);
        if(e.target.value.length >= 2){
            setTextStatus(true);
        }else{
            setTextStatus(false);
        }
    }
    
    return (
        <div className={ ( currentQuestion != 12 ? ("question-view question-view-md") : ("question-view question-view-lg")) + ( Animation ? ' animation-start' : " animation-stop") }>
            <div className="question-headline">
                {!WalkIn ? parse(questionHeadline) : <> {currentQuestion == 2 ? "Welche Befestigungsart wünschen Sie ?": parse(questionHeadline)} </>}
                
            </div>  
            <div className={currentQuestion != 12 ? (`question-answer-handler ${"question-number-"+currentQuestion}`) : ("question-answer-handler-checkbox") }>
            {getAllQuestions[currentQuestion].answers.map(({title, check, icon = null, nextQuestions = null, title2}, index) => (
                

                <button key={index} className="question-answer-item-handler" disabled={Animation} style={{ display: (WalkIn && title2) != "XX" ? "block" : "none" }}>
                {!nextQuestions ? 
                <>

                    {title && 
                    <div className="question-item" onClick={() => handleQuestionSelectClick(title)}>
                        {icon && <i>
                            {getImage(icon)}
                        </i>}
                    
                        {!WalkIn ? 
                            <span>{title}</span> 
                            : 
                            <>
                            {currentQuestion == 2 ? 
                                <span>{title2}</span>
                            : 
                                <span>{title}</span>}
                            </>
                        }

                        {nextQuestions ? 
                            <textarea placeholder={"Hier bitte eintragen..."} onChange={handleInputChange}></textarea>
                        : null}

                    </div>
                    }
                    {check && 
                    <div className="checkbox-item container-box">
                        <input type="checkbox" id={check} name={check} value={check} onChange={onCheckedValue} />
                        <label className="checkmark" htmlFor={check}>{check}</label>
                    </div>
                    }
                </>
                : 
                <>
                    {title && 
                    <div className="question-item">
                        {icon && <i>
                            {getImage(icon)}
                        </i>}
                        <span>{title}</span>
                        {nextQuestions ? 
                        <>
                            <input placeholder={"Ihr Wunschmaß in cm"} onChange={handleInputChange} />
                            <>
                            {textStatus ? 
                                <span className="textarea-checker" onClick={() => handleQuestionSelectClick(questionData)}>
                                    Weiter
                                    <i>
                                        
                                    </i>
                                </span>
                                : 
                            null}
                            </>
                        </>
                        : null}
                    </div>
                    }

                    {check && 
                    <div className="checkbox-item container-box">
                        <input type="checkbox" id={check} name={check} value={check} onChange={onCheckedValue}></input>
                        <label className="checkmark" htmlFor={check}>{check}</label>
                    </div>
                    }
                </>
                }
                </button>



            ))}
            </div>
            <div className="submit-handler">
            {currentQuestion >= 1 && <div className="back-btn"> <button onClick={() => handleQuestionBackClick()}> Zurück </button> </div> }
            </div>
        </div>
    )
}

export default QuestionView
